import { render, staticRenderFns } from "./LogOptimizationGroupFilter.vue?vue&type=template&id=4f8a3fee&"
import script from "./LogOptimizationGroupFilter.vue?vue&type=script&lang=js&"
export * from "./LogOptimizationGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports